/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const WorkflowJobWorkerJsonApiModel = {
  id: "",
  pid: "",
  "commit-id": "",
  metadata: "",
  "created-at": "",
  "updated-at": "",
};
